/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoresGetResponse } from '../../models/stores-get-response';

export interface AggregatorsDoordashStoresGet$Params {
  'Active-Tenant-Identifier': string;
  exchangeCode: string;
}

export function aggregatorsDoordashStoresGet(http: HttpClient, rootUrl: string, params: AggregatorsDoordashStoresGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StoresGetResponse>> {
  const rb = new RequestBuilder(rootUrl, aggregatorsDoordashStoresGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('exchangeCode', params.exchangeCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoresGetResponse>;
    })
  );
}

aggregatorsDoordashStoresGet.PATH = '/aggregators/doordash/stores';
